import { render } from "./multi-bet-view.vue?vue&type=template&id=77e84a5a&ts=true"
import script from "./multi-bet-view.vue?vue&type=script&lang=ts"
export * from "./multi-bet-view.vue?vue&type=script&lang=ts"

import "./multi-bet-view.vue?vue&type=style&index=0&id=77e84a5a&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__